import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useCreateBillingGroupValidationSchema = () => {
  const { t } = useTranslation(['billingGroups', 'validation']);

  return z.object({
    name: z
      .string()
      .min(1, t('billingGroups:create.required'))
      .max(
        255,
        t('validation:maxCharacters', {
          count: 255,
        }),
      ),
    discountTemplatesIds: z.array(z.number()),
  });
};
